import { XingletLoader } from '@xing-com/crate-xinglet';

import type { CommboxProps } from './types/props';

export type { CommboxProps, CommboxSuccessBannerProps } from './types/props';
export type { CommboxFeaturePermissionsType } from './types/commbox-feature-permissions-type';
export type { CommboxApplicationType } from './types/commbox-application-type';
export type { CommboxErrorMessageType } from './types/commbox-error-message-type';
export { ATTACHMENT_TYPES, COMMBOX_ACTOR_TYPES } from './constants/public';

export const EntityPagesCommbox: React.FC<CommboxProps> = (props) => {
  return (
    <XingletLoader name="@xing-com/crate-commbox-commbox-xinglet" {...props} />
  );
};
